/**
 * AI CONTEXT
 * Purpose: current-time triangle marker for timeline view.
 * Inputs: pixel position + overflow state.
 * Used by: ClassScheduleTimeline.
 * Refactor: parameterize marker shape/size via constants for easier styling.
 */
import { Tooltip } from "antd"
import styled from "styled-components"

import { Hexcode, useThemeContext } from "#contexts/ThemeContextProvider"
import { formatTimeLocale, getNow } from "#utils/dateHelpers"

const SMarker = styled.div<{
  currentTimePosition: number
  color: Hexcode
}>`
  position: absolute;
  top: ${({ currentTimePosition }) => currentTimePosition}px;
  left: -50px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: ${({ color }) => `15px solid ${color}`};
  z-index: 1000;
  transition: all 0.1s ease-in-out;

  &:hover {
    cursor: pointer;
    left: -48px;
    border-left: ${({ color }) => `12px solid ${color}`};
  }
`

const CurrentTimeMarker = ({
  currentTimePosition,
  isOverflow,
}: {
  currentTimePosition: number
  isOverflow: boolean
}) => {
  const theme = useThemeContext()

  return (
    <Tooltip
      title={`Current time: ${formatTimeLocale(getNow())}`}
      placement="left"
    >
      <SMarker
        currentTimePosition={currentTimePosition}
        color={isOverflow ? theme.gray[7] : "#ff4d4f"}
      />
    </Tooltip>
  )
}

export default CurrentTimeMarker
